export const headers = [
  { label: "Username", key: "userName" },
  { label: "Email", key: "email" },
  { label: "Date Joined", key: "createdDateCSV" },
  { label: "Last Login", key: "lastLoginCSV" },
  { label: "Email confirmed", key: "emailConfirmed" },
  { label: "UTM Source", key: "utmSource" },
  { label: "UTM Medium", key: "utmMedium" },
  { label: "UTM Campaign", key: "utmCampaign" },
];
